// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1D2dr","label":"Completed_label__CvonM"};